<template>
    <button v-if="product.shop_availability" :class="`btn btn-primary btn-${size} w-100`" @click.prevent="cartStore.storeUpdateSave(product.id, quantity, false, product.order_quantity_step)">
        <img v-if="small" src="@img/icons/cart-w.svg" loading="lazy" alt="{{ $t('Add to cart') }}">
        <span v-else>{{ $t('Add to cart') }}</span>
    </button>
</template>

<script setup>
import {useCartStore} from '~/stores/CartStore';
const cartStore = useCartStore()
</script>

<script>
export default {
    props: {
        product: {
            required: true,
            type: Object
        },
        icon: Boolean,
        size: {
            default: 'lg',
            type: String
        },
        small: {
            type: Boolean,
            default: false
        },
        showTrash: {
            type: Boolean,
            default: true
        },
        quantity: {
            type: Number,
            default: 1
        }
    }
};
</script>
